import { JSX } from 'react';

// components
import { OrContentBlock } from '../or-content-block';
import { MlAccordion } from '@/components/molecules';

// types
import { IOrfaqListProps } from './or-faq-list.types';

export const OrFaqList = ({
  children,
  theme,
  RenderLeftContent,
  topSpacing = 'md',
  bottomSpacing = 'md',
  topDivider = false,
  bottomDivider = false,
}: IOrfaqListProps): JSX.Element => {
  return (
    <OrContentBlock
      topSpacing={topSpacing}
      bottomSpacing={bottomSpacing}
      topDivider={topDivider}
      bottomDivider={bottomDivider}
      data-testid="or-faq-list"
      theme={theme}
      RenderLeftContent={RenderLeftContent}
    >
      <MlAccordion className="col-span-2">{children}</MlAccordion>
    </OrContentBlock>
  );
};
